import * as React from "react";
const SvgFiRrBowlSpoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bowl-spoon_svg__a)">
      <path
        fill="#062147"
        d="M6.293 8c1.974 0 3.624-1.279 4.099-3h12.607a1 1 0 1 0 0-2H10.392c-.475-1.721-2.125-3-4.099-3C4.132 0 0 1.558 0 4s4.132 4 6.293 4m0-6c1.241 0 2.25.897 2.25 2s-1.009 2-2.25 2C4.566 6 2 4.688 2 4s2.566-2 4.293-2m17.034 10.498A3.71 3.71 0 0 0 20.33 11H3.669c-1.19 0-2.283.546-2.997 1.498a3.75 3.75 0 0 0-.602 3.329c.652 2.233 1.834 4.248 3.42 5.826C4.986 23.144 7.101 24 9.293 24h5.411c2.191 0 4.307-.855 5.805-2.347 1.585-1.578 2.767-3.593 3.419-5.826a3.75 3.75 0 0 0-.602-3.329m-1.318 2.769c-.55 1.883-1.583 3.647-2.911 4.969-1.126 1.122-2.727 1.765-4.394 1.765H9.293c-1.667 0-3.268-.643-4.394-1.765-1.327-1.321-2.361-3.086-2.91-4.969a1.76 1.76 0 0 1 .281-1.568 1.73 1.73 0 0 1 1.396-.698h16.662a1.73 1.73 0 0 1 1.396.698c.339.451.441 1.023.282 1.568z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-spoon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlSpoon;
